<!--  -->
<template>
  <MyMenu />
</template>

<script>
import MyMenu from "./components/menu";


export default {
  name: "MyLayout",
  components: {
    MyMenu,

  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang='scss' scoped>
</style>